import React from 'react';
import { useTranslation } from 'react-i18next';
import { Title, Text, Button, Card } from '@tremor/react';
import { SparklesIcon, ScaleIcon } from '@heroicons/react/24/outline';
import { useBehavioralArtifact } from './useBehavioralArtifact';
import UpgradedLoader from '../UpgradedLoader';

/**
 * Part 2: cognitive biases related to the researcher's field of study, AI-selected.
 */
function BeBiasesTab({ projectUuid, analysisUuid }) {
    const { t } = useTranslation();
    const { status, result, loading, generate } = useBehavioralArtifact(projectUuid, analysisUuid, 'be_biases');

    const biases = Array.isArray(result) ? result : [];

    return (
        <div data-testid="be-biases-tab">
            <div className="flex items-center justify-between mb-2">
                <div className="flex items-center space-x-3">
                    <ScaleIcon className="h-6 w-6 text-iavisus-100" />
                    <Title className="text-lg font-semibold">{t('BehavioralEconomics.Biases.Title')}</Title>
                </div>
                {status !== 'processing' && (
                    <Button icon={SparklesIcon} onClick={generate} className="bg-iavisus-900">
                        {status === 'completed' ? t('BehavioralEconomics.Regenerate') : t('BehavioralEconomics.Generate')}
                    </Button>
                )}
            </div>
            <Text className="mb-4">{t('BehavioralEconomics.Biases.Description')}</Text>

            {(loading || status === 'processing') && <UpgradedLoader />}
            {status === 'failed' && <Text className="text-red-600">{t('BehavioralEconomics.Error')}</Text>}
            {status === 'not_started' && !loading && <Text className="text-gray-500">{t('BehavioralEconomics.Biases.Empty')}</Text>}

            {status === 'completed' && biases.length > 0 && (
                <div className="space-y-3">
                    {biases.map((b, i) => (
                        <Card key={i} className="p-4">
                            <Title className="text-base font-bold text-iavisus-100">{b.name}</Title>
                            {b.definition && <Text className="mt-1 italic text-gray-600">{b.definition}</Text>}
                            {b.why_relevant_to_study && <Text className="mt-2">{b.why_relevant_to_study}</Text>}
                        </Card>
                    ))}
                </div>
            )}
        </div>
    );
}

export default BeBiasesTab;
